import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Scripts from '../Tabs/Script';
import Notes from '../Tabs/Notes';
import GroupMembers from '../Tabs/GroupMembers';
import Users from '../Tabs/Users';
import accountHelpers from '../../../../../utils/accountHelpers';

export const usePhysicianTabs = (type) => {
  const { physicianId, groupName, healthId } = useParams();

  const tabs = useCallback(() => {
    let tabTypes = [
      {
        name: 'Scripts',
        content: <Scripts type={type} />,
      },
      {
        name: 'Appointments/Notes',
        content: <Notes type={type} />,
      },
      {
        name: 'Group Members',
        content: <GroupMembers />,
      },
      {
        name: 'Users',
        content: <Users type={type} />,
      },
    ];

    if (type === 'health') {
      tabTypes = tabTypes.filter((t) => t.name === 'Scripts' || t.name === 'Users');
    }

    const requestData = {
      userId: accountHelpers.getUser().id,
      revenue: true,
    };

    if (type === 'group') {
      requestData.group = groupName;
    } else if (type === 'health') {
      requestData.healthId = healthId;
    } else {
      requestData.physicianId = physicianId;
    }

    return { tabs: tabTypes, requestData };
  }, [type]);

  return tabs();
};

usePhysicianTabs.propTypes = {
  type: PropTypes.string,
};

usePhysicianTabs.defaultProps = {
  type: '',
};
